import moment from "moment";
import React from "react";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";

function View(props) {
  const { rowData } = props;

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header className="border-0">
            <h5>View BOM Details</h5>
            <div className="card-header-action">
              <Link
                className="btn btn-underline me-2"
                onClick={props.onBackClick}
              >
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Row className="mb-3">
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  BOM Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.bom_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Product Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.product_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Product Code
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.product_code || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Machine Type
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.machine_type || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Plant Location
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.plant_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {moment(rowData.createdAt).format("DD-MM-YYYY hh:mm A") || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Created By
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.created_name || "-"}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row>
              <RB.Col xs={12}>
                <h6 className="text-uppercase fw-bold small text-body-secondary">
                  BOM Recipe Items
                </h6>
                <div className="table-responsive">
                  <RB.Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Item Code</th>
                        <th>Unit</th>
                        <th>Quantity</th>
                        <th>BOM Date</th>
                        <th>Category</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rowData.bom_recipe && rowData.bom_recipe.length > 0 ? (
                        rowData.bom_recipe.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.item_code || "-"}</td>
                            <td>{item.unitName || "-"}</td>
                            <td>{item.qty || "-"}</td>
                            <td>{moment(item.bom_date).format("DD-MM-YYYY") || "-"}</td>
                            <td>{item.category_name || "-"}</td>
                            <td>{item.creator_name || "-"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No items available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </RB.Table>
                </div>
              </RB.Col>
            </RB.Row>
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default View;
